<script setup="">
import PageBlockContainer from "@page-js/Pages/Page/Editor/Partials/PageBlockContainer.vue";
import PageBlockEditor from "@page-js/Pages/Page/Editor/scripts/pageBlockEditor";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  pageMeta: {
    type: Object,
    required: true
  }
});

const editor = new PageBlockEditor(props.pageMeta, { blockFieldName: "content" });
</script>

<template>
  <PageBlockContainer :editor="editor">
    <div class="block-container block">
      <template v-for="block in editor.blocks" :key="block.id">
        <component :is="block.getRenderComponent()" :editor="editor" :block="block" />
      </template>
    </div>
  </PageBlockContainer>
</template>
